import { AppProvider as PolarisAppProvider } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/en.json';

interface ShopifyAppProviderProps {
  children: React.ReactNode;
}

// Get shop and host from URL params (passed by Shopify when embedded)
function getShopifyParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    shop: params.get('shop'),
    host: params.get('host'),
  };
}

// Check if we're running inside Shopify Admin (embedded)
function isEmbedded(): boolean {
  // Check if host param exists (only present when embedded)
  const { host } = getShopifyParams();
  if (host) return true;
  
  // Also check if we're in an iframe
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export function ShopifyAppProvider({ children }: ShopifyAppProviderProps) {
  // In App Bridge 4.x, the bridge is initialized automatically when 
  // running inside Shopify Admin. We just need to provide Polaris.
  return (
    <PolarisAppProvider i18n={translations}>
      {children}
    </PolarisAppProvider>
  );
}

// Hook to get embedded status
export function useEmbedded() {
  return {
    isEmbedded: isEmbedded(),
    params: getShopifyParams(),
  };
}
